import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=c345d58c&scoped=true"
import script from "./course-list.vue?vue&type=script&lang=ts"
export * from "./course-list.vue?vue&type=script&lang=ts"
import style0 from "./course-list.vue?vue&type=style&index=0&id=c345d58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c345d58c",
  null
  
)

export default component.exports